// Clasificación de variables del diccionario en numéricas/categóricas.
// La usan Regresión, Bootstrap, Crosstabs y Series de tiempo para guiar al usuario.
import type { VariableEntry } from "../api/endpoints";

export type VarKind = "numeric" | "categorical" | "other";

export function varKind(v: VariableEntry): VarKind {
  const t = (v.type ?? "").toLowerCase();
  if (t.startsWith("select_")) return "categorical";
  if (["integer", "decimal", "calculate"].some((k) => t.includes(k))) return "numeric";
  if (v.choices && Object.keys(v.choices).length > 0) return "categorical";
  return "other";
}
